import { ProgressSpinner } from 'primereact/progressspinner'
import { FC, useEffect, useRef, useState } from 'react'
import { toast } from 'react-hot-toast'
import { useNavigate, useParams } from 'react-router-dom'
import { useSearchParams } from 'react-router-dom'
import {
  useGetSubmissions,
} from '../api/submission-API'

import { protoService } from '../proto/ProtoService'
import { WorkflowSubmission } from '../types/types'
import { queryString2JsonString } from '../types/util'

const SubmissionCase: FC = () => {
  const params = useParams()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const [error, setError] = useState<string | null>(null)
  const [{ loading: loadingSubmission }, findSubmission] = useGetSubmissions()

  useEffect(() => {
    setError('')
    const query = queryString2JsonString(
      'workflowRunGroups.systemRunId=' + encodeURIComponent(JSON.stringify(params.id))
    )
    findSubmission(`query=${query}`).then(({ data: submissionData }) => {
      if (submissionData) {
        const submission = protoService.decodeProtoResponse(
          submissionData,
          'workflowsubmission'
        ) as WorkflowSubmission[]
        if (submission.length) {
          // Preserve raceTeamId query parameter if present
          const raceTeamId = searchParams.get('raceTeamId')
          const queryParams = new URLSearchParams({ case: params.id || '' })
          if (raceTeamId) {
            queryParams.append('raceTeamId', raceTeamId)
          }
          navigate(`/submissions/${submission[0].name}?${queryParams.toString()}`, { replace: true })
        } else {
          setError('The case does not exist.')
          toast.error('The case does not exist.')
        }
      }
    }).catch((err) => {
      console.error(err)
      toast.error('Error loading workflow submission.')
    })
  }, [params.id])

  return (
    <div className="w-full flex items-center justify-center  h-[300px]">
      {loadingSubmission && (
        <div className="w-full h-96 flex flex-col justify-center items-center space-y-4">
          <ProgressSpinner strokeWidth="3" style={{ width: '24px', height: '24px' }} color='' />
          <div className="text-lg font-medium text-gray-700">Loading run...</div>
        </div>
      )}
      {error && (
        <div className="w-full h-96 flex flex-col justify-center items-center space-y-4">
          <div className="text-lg font-medium text-red-600">{error}</div>
        </div>
      )}
    </div>
  )
}


export default SubmissionCase
